export default __webpack_public_path__ + "static/media/snake.b146017e.png";